/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popTip.vue?vue&type=template&id=4e4e4010&scoped=true"
import script from "./popTip.vue?vue&type=script&lang=js"
export * from "./popTip.vue?vue&type=script&lang=js"
import style0 from "./popTip.vue?vue&type=style&index=0&id=4e4e4010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e4010",
  null
  
)

export default component.exports